/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CommonBannedAsinBulkCopyDTO interface.
 */
export function instanceOfCommonBannedAsinBulkCopyDTO(value) {
    if (!('targetMarketplaces' in value) || value['targetMarketplaces'] === undefined)
        return false;
    return true;
}
export function CommonBannedAsinBulkCopyDTOFromJSON(json) {
    return CommonBannedAsinBulkCopyDTOFromJSONTyped(json, false);
}
export function CommonBannedAsinBulkCopyDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ids': json['ids'] == null ? undefined : json['ids'],
        'selectAll': json['selectAll'] == null ? undefined : json['selectAll'],
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'targetMarketplaces': json['targetMarketplaces'],
        'addToAsins': json['addToAsins'] == null ? undefined : json['addToAsins'],
        'addToBrands': json['addToBrands'] == null ? undefined : json['addToBrands'],
        'search': json['search'] == null ? undefined : json['search'],
    };
}
export function CommonBannedAsinBulkCopyDTOToJSON(json) {
    return CommonBannedAsinBulkCopyDTOToJSONTyped(json, false);
}
export function CommonBannedAsinBulkCopyDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ids': value['ids'],
        'selectAll': value['selectAll'],
        'marketplace': value['marketplace'],
        'targetMarketplaces': value['targetMarketplaces'],
        'addToAsins': value['addToAsins'],
        'addToBrands': value['addToBrands'],
        'search': value['search'],
    };
}
